import { ThemeProvider } from "@mui/material";
import HOC from "../../../components/HOC";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import AddInitialAnalysis from "../../../components/screen/patientCare/patientCareInitialAnalysis/AddInitialAnalysis";
import { theme } from "../../../components/constants/muiTheme";

const AddInitialAnalysisListPage = ({ isDetail }) => {
  return (
    <PageTemplate
      header="Tambah Initial Analysis"
      mainComponent={
        <ThemeProvider theme={theme}>
          <AddInitialAnalysis isDetail={isDetail} />
        </ThemeProvider>
      }
      pageRole={18}
    />
  );
};

export default HOC(AddInitialAnalysisListPage);
